import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { themeGet } from '@lightspeed/flame/Core';
import { Input } from '@lightspeed/flame/Input';
import { InputGroup } from '@lightspeed/flame/InputGroup';
import { Text } from '@lightspeed/flame/Text';

export const StyledButton = styled(Button)`
  width: 40px;
  min-width: 40px;
  max-width: 40px;
  justify-content: center;
  color: #232a3b;
  font-weight: bold;
  font-size: ${themeGet('space.3')};
`;

export const StyledInputGroup = styled(InputGroup)`
  max-width: 165px;
  > div {
    width: auto !important;
  }
`;

export const StyledInput = styled(Input)`
  text-align: center;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0px;
  width: 72px;
  max-width: 85px;
  &:disabled {
    opacity: 0.5;
  }
  + div {
    border: 1px solid ${themeGet('colors.gray-200')};
  }
`;

export const StyledError = styled(Text)`
  color: ${themeGet('colors.maple-500')};
  font-size: ${themeGet('space.2')};
  margin-top: ${themeGet('space.1')};
`;
